import { render, staticRenderFns } from "./ModuleContent.vue?vue&type=template&id=37668bd6"
import script from "./ModuleContent.vue?vue&type=script&lang=ts"
export * from "./ModuleContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports